<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17IzZs4/tc-custom/9780544326606.jpg?1734280284376" alt="This image is the cover for the book American Ambassador"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Ambassador
      </h1>
      <p class="bookDescription body article font2">
        <b>“A gripping international thriller” about a Foreign Service officer—and the son who turns to terrorism to spite him (<i>Los Angeles Times</i>).</b><br/><br/> William North Jr. inherited his father’s keen political instincts and passion for justice. But the last time Ambassador North saw his son he seemed like a stranger—and a hostile one at that. Now, just as North prepares to take a new post in Germany, reports emerge that Bill Jr. is aligned with a German terrorist organization.<br/>  <br/> Suddenly, a private conflict between father and son escalates to a matter of national security. North is faced with a terrifying dilemma as loyalty to family and country are directly at odds.<br/>  <br/><i>The American Ambassador</i> is at once a riveting tale of suspense and a thoughtful meditation on the fragility of Western values in an age of terrorism.<br/>  <br/> “Haunting and persuasive . . . Charged with authenticity . . . A splendid book that is both thoughtful and fast-moving.” —<i>The New York Times</i><br/>  <br/> “To make out the jagged intersections of ambition and greed, idealism and sell-out in contemporary politics, you need only turn to . . . <i>The American Ambassador</i>.” —Salon.com
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ward Just
      </h2>
      
      <p class="authorDescription body article">Ward Just&rsquo;s novels include <I>Exiles in the Garden</I>; <I>Forgetfulness</I>; National Book Award finalist <I>Echo House</I>; <I>A Dangerous Friend</I>, winner of the James Fenimore Cooper Prize for fiction from the Society of American Historians; and <I>An Unfinished Season</I>, winner of the <I>Chicago Tribune</I>&rsquo;s Heartland Prize and a finalist for the 2005 Pulitzer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dd2a946a